<template lang="pug">
.page-nft-all.text-left.p-3
  .container.pt-md-5.pb-md-5(v-if="!workName")
    .catalog-head
      h1.catalog-title {{ $t('nft.catalog.title') }}
      p.catalog-sub {{ $t('nft.catalog.subtitle') }}
    details.nft-index-disclosure
      summary {{ $i18n.locale === 'zh' ? '瀏覽全部系列' : 'Browse all series' }} · {{ collectionRecords.length }}
      nav.nft-record-index(:aria-label="$i18n.locale === 'zh' ? '各系列作品檔案' : 'Artwork records by series'")
        router-link(v-for="record in collectionRecords", :key="record.slug", :to="recordPath(record.slug)") {{ $i18n.locale === 'zh' ? record.titleZh || record.title : record.title }} →
    component.row.py-3.nft-item(
      v-for="item in nftItems",
      :is="getLinkComponent(item.url)",
      :href="item.url",
      :to="withSlash(($i18n.locale === 'zh' && item.url.startsWith('/') && !item.url.startsWith('/zh/') ? '/zh' : '') + item.url)",
      target="_blank",
      :key="item.id"
    )
      .col-md-5.col-lg-6
        img.w-100(:src="item.imageUrl", :alt="item.title")
      .col-md-7.col-lg-6
        h2 {{ item.title }}
        h3
        h5 {{ item.platform }}, {{ item.date }}, {{ item.editions }} editions
        p(v-html="item.description1")
        p(v-html="item.description2")

    //- 2026-09-20：卡連統合頁 /work/memes-6529/；19 MB 的 GIF 換成本地靜幀（動態在作品頁）
    router-link.row.py-3.nft-item(:to="recordPath('memes-6529')")
      .col-md-5.col-lg-6
        img.w-100(src="/static/img/memes-6529/cover-2026-09.jpg", alt="")
        //- iframe.w-100(
        //-   src="https://ipfs.io/ipfs/bafybeig7eymxakrydhgok5ixunaxszoewdizlkw2afohg6js5j7ajjiuvi",
        //-   style="width: 100%; aspect-ratio: 1; border: none"
        //- )

      .col-md-7.col-lg-6
        h2 Hamily x The Memes by 6529 x Che-Yu Wu
        h3
        h5 Season 2, Card 2 | 2023/3/2 | 690 editions
        p Amidst the crowd, the hams lie low,
          br
          | Scaling peaks and valleys, high and low,
          br
          | We're a meme community, unique and bold,
          br
          | Creating waves of madness, untold.
        p Our force is strong, our power great,
          br
          | Recreating trends, we never wait,
          br
          | Stealing the spotlight with style and flair,
          br
          | Leaving the world in awe and in despair.
        p Join us now, be a part of this art,
          br
          | The world of hams and memes, it's just the start,
          br
          | For we'll keep on rising, day by day,
          br
          | With our crazed creativity on full display.
        h3 Interactivity:
        ul
          li Move the mouse around to WAGMI with the hams
          li Press S to download image
          li Press H to go to the Hamily website

    a.row.py-3.nft-item(
      href="https://app.manifold.xyz/c/230206-Memegineering",
      target="_blank"
    )
      .col-md-5.col-lg-6
        img.w-100(
          :src="collectionRecords.find(record => record.slug === 'memegineering').cover",
          alt=""
        )

      .col-md-7.col-lg-6
        h2 230206 MEMEGINEERING
        h3
        h5 Che-Yu Wu Interactive Memes | 2023 | 420 editions
        p Piping interactive memes as the digital blood of the internet.
        p Memegineering is all about bringing dynamic and interactive experiences to the world of memes. These memes are not just static images, but rather they are designed to be interactive, allowing users to engage with the content in a unique and exciting way. Whether you're clicking, tapping, or scrolling, these memes are sure to provide a fun and dynamic experience that will keep you entertained for hours. With 420 editions, there's a never-ending supply of interactive memes to explore, making Memegineering a must-see for anyone who loves humor, memes, and the internet.
    //- 2026-10-03：/nft/thesoul/ 退役（301 → /work/the-soul/）；ipfs.io 對鑄造版 CID 回 429，live iframe 換成本站封面（鑄造版自架在 the-soul.art.cheyuwu.com）
    router-link.row.py-3.nft-item(:to="recordPath('the-soul')")
      .col-md-5.col-lg-6
        img.w-100(
          src="/static/img/the-soul/cover-2026-10.jpg",
          alt="The Soul",
          loading="lazy",
          style="width: 100%; aspect-ratio: 3 / 2; object-fit: cover"
        )

        //- img.w-100(
        //-   src="https://gateway.fxhash2.xyz/ipfs/QmSjD9c2S8tN4f8QpJSRtxHhkKRtpiA8LmEoNRWAdxANW7",
        //-   alt=""
        //- )
      .col-md-7.col-lg-6
        h2 The Soul
        h3
        h5 Che-Yu Wu Interactive Collection | 2023 | 100 editions
        p In the darkness, the vast eyes of the universe gaze upon you, their pupils aglow with hues and radiance beyond this realm, inquiring about the essence of your being.
        p "The Soul" was inspired by Olafur Eliasson's "The Weather Project" installation from 2003, as well as the brand visual for the 2021 Solana Breakpoint Conference. The use of fluorescent colours and gradients in the conference's branding inspired the use of these elements in my own work.
        p I developed while attending the conference. The work aims to bring the outside world inside and create a cosmic vision for the audience to experience. The work is meant to resemble an immense, floating eye staring into the void and asking the audience to consider the meaning of life and their deepest desires.
    //- 2026-09-20：靈魂魚五址歸一。這張卡連到統合頁 /work/soulfish/；fxhash gateway 已停站，live iframe 換成本站封面。
    router-link.row.py-3.nft-item(:to="recordPath('soulfish')")
      .col-md-5.col-lg-6
        img.w-100(
          src="/static/img/soulfish/cover-2026-09.jpg",
          alt="SoulFish",
          loading="lazy",
          style="width: 100%; aspect-ratio: 3 / 2; object-fit: cover"
        )
      .col-md-7.col-lg-6
        h2 SoulFish
        h3
        h5 fxhash, June 30th 2022, 400 editions
        p Named after the artist Wu Che-Yu, the soul fish was born in the void and crystallized from human emotions.
        p Fluttering silently and slowly, their bodies almost disappeared in the light of the deep sea.<br></br>The fish swims freely, and this is the happiness of the fish.
        p If we are not a fish, how do we know the joy of a fish?<br>How do we know that we do not know the joy of fish?
        p We will only learn about it when we come to the riverside.
        p.mt-3 {{ $i18n.locale === 'zh' ? '作品頁：來歷、基因、聲音、展場與 400 版 →' : 'Work page: origin, genome, sound, exhibitions and the 400 editions →' }}

    //- 2026-10-04：百岳計畫卡改連統合頁 /work/fabdao/（原本外連 fab.tw，網域已是待售頁）；封面＝林茲五屏同播《島嶼》；/nft/fabdao/ 是《島嶼》569 枚資料庫
    router-link.row.py-3.nft-item(:to="recordPath('fabdao')")
      .col-md-5.col-lg-6
        img.w-100(src="/static/img/fabdao/cover-2026-10.jpg", alt="Project % · Island", loading="lazy", style="width: 100%; aspect-ratio: 3 / 2; object-fit: cover")
      .col-md-7.col-lg-6
        h2 Project % · Island
        h3
        h5 July 2nd 2022 | Ethereum | Island: 569 of the 2,845 tokens
        p One of the five mountain ranges of Project %, the charity NFT project led by Mashbean and released by FAB DAO (Formosa Art Bank). Five Taiwanese generative artists each wrote one 9:16 mountain; Che-Yu Wu's is Island, illustrated ridges and mist computed in real time with p5.js and a GLSL shader. Shown at Ars Electronica in Linz in September 2022.
        p.mt-3 {{ $i18n.locale === 'zh' ? '作品頁：五段山脈、shader、林茲與松菸，以及《島嶼》569 枚資料庫 →' : 'Work page: the five ranges, the shader, Linz and Songshan, and the 569 Island tokens →' }}
    //- 2026-09-20：靈魂海兩址歸一。這張卡連到統合頁 /work/soulsea/（原本連 fxhash，平台已 402）；封面換 2024 年他親挑的渲染
    router-link.row.py-3.nft-item(:to="recordPath('soulsea')")
      .col-md-5.col-lg-6
        img.w-100(
          src="/static/img/soulsea/cover-2026-09.jpg",
          alt="SoulSea",
          loading="lazy",
          style="width: 100%; aspect-ratio: 3 / 2; object-fit: cover"
        )
      .col-md-7.col-lg-6
        h2 SoulSea
        h3
        h5 fxhash, Dec 29th 2021, 300 editions
        p You look down and find that the ocean in your heart is a sine wave.<br>The tide gently laps onto the shore.
        p The soul is the sea. You are the land.<br/>There are waves on the shore, and the waves are slices.
        p Gazing at the slices, you feel the coldness of the Arctic Ocean, the permafrost of the Antarctic Sea, the deep darkness of the bottomless sea.
        p Stay silent, hear the sound of the waves lapping at the innumerable shores far away.<br>Feel the soul of the digital ocean.
        p.mt-3 {{ $i18n.locale === 'zh' ? '作品頁：來歷、聲音、展出與 300 版 →' : 'Work page: origin, sound, exhibitions and the 300 editions →' }}

    //- 2026-09-20：Sliderverse 統合頁 /work/sliderverse/（原本外連已死的 sliderverse.doodlelabs.io）；封面改本地 #1272；版數照鏈上 1285／5001；平台名 Doodle Labs
    router-link.row.py-3.nft-item(:to="recordPath('sliderverse')")
      .col-md-5.col-lg-6
        img.w-100(src="/static/img/sliderverse/cover-2026-09.jpg", alt="")
      .col-md-7.col-lg-6
        h2 Sliderverse
        h3
        h5 Doodle Labs (Art Blocks Engine), Dec 15th 2021 | 1285 of 5001 editions
        p In honor of White Castle's 100th Birthday, renowned multimedia artist Che-Yu Wu has reimagined the White Castle menu through a generative art lens. Each unique edition within this series of collectible NFTs is generated by an algorithm at the time of mint, pushing the boundaries of physics, mathematics, and art. This series combines Che-Yu's signature, interactive style with White Castle's legendary sliders to explore the intersection between food, art, tech and culture.
        p And in keeping with White Castle's spirit of feeding the souls of their communities and team members, a portion of the proceeds from Sliderverse will directly benefit our Team Member Relief Fund and the Ingram-White Castle Team Member Scholarship.

    //- 2026-09-20：Electriz 統合頁 /work/electriz/（原本連 2021 子頁 /nft/electriz/，那條路現在是 910 版資料庫）；封面改本地 #0（原本外鏈 media.artblocks.io）
    router-link.row.py-3.nft-item(:to="recordPath('electriz')")
      .col-md-5.col-lg-6
        img.w-100(src="/static/img/electriz/cover-2026-09.jpg", alt="")
      .col-md-7.col-lg-6
        h2 Electriz
        h3
        h5 Art Blocks #216, Dec 7th 2021, 910 editions
        p "Electriz" is a series of works that use digital cloud chambers to observe the traces of unidentified particles. When doing art creation, just like scientists discovering new particles, artists continue to draw interesting ideas from reality and fantasy to collide with each other, trying to find a unique existence at the moment of collision in the process of mixing ideas.
        p The space in the work "Electriz" is divided into parts with different physical characteristics, which affect the movement, rotation, splitting, and annihilation of particles. It is an unpredictable experimental system with unlimited possibilities to explore the intersection of physics, mathematics, and art.

    //- 2026-09-20：波奇統合頁 /work/cryptopochi/（原本外連 cryptopochi.com）；封面＝#26 由 2021 鑄造版生成器重跑；「732/732」改「732 editions」（合約上限 1500，鑄到 732 封盤，不是售罄）
    router-link.row.py-3.nft-item(:to="recordPath('cryptopochi')")
      .col-md-5.col-lg-6
        img.w-100(src="/static/img/cryptopochi/cover-2026-09.jpg", alt="")
      .col-md-7.col-lg-6
        h2 CryptoPochi
        h3
        h5 Sep 5th 2021 | 732 editions
        p CryptoPochis are mysterious creatures that capture different emotions in your daily life. Their faces speak for themselves. They simply lie on the ground and play all day. We catch and wrap them as NFTs for you to play with.

    //- 2026-09-20：這張卡原本貼的是衍生作在 Art Blocks 上的說明；改成原作＋家族，連統合頁 /work/strange-robot/
    router-link.row.py-3.nft-item(:to="recordPath('strange-robot')")
      .col-md-5.col-lg-6
        img.w-100(src="/static/img/strange-robot/cover-2026-09.jpg", alt="")
      .col-md-7.col-lg-6
        h2 Strange Robots → The Hamily
        h3
        h5 March 28th 2021 | daily sketch → Sea Hams → The Hamily
        p A hundred little robots from one night in March 2021. The code was taken to Art Blocks as sail-o-bots; Art Blocks arbitrated half the royalties back to the original author, the community named the robots Sea Hams, and a family called The Hamily grew out of it: twenty-six hand-drawn Craft Hams, three Atoms of Ham, and card 74 of The Memes by 6529.

    router-link.row.py-3.nft-item(:to="($i18n.locale === 'zh' ? '/zh' : '') + '/nft/foundation/'")
      .col-md-5.col-lg-6
        img.w-100(
          src="https://f8n-ipfs-production.imgix.net/QmdDNqJ9J9fEsTAaBjmdnHZ1px2zGS8BXnUnBvzdQCwSaN/nft.jpg?q=80&auto=format%2Ccompress&cs=srgb&max-w=1680&max-h=1680",
          alt=""
        )
      .col-md-7.col-lg-6
        h2 Foundation Classic Series
        h3
        h5 July 1st 2021
        p [Che-Yu Wu | Generative Art 4K Classic series]
        p Classic series will only mint a maximum of 10 works per algorithm on Foundation.
  .container.pt-2.pb-md-4
    router-link.back-link(:to="$i18n.locale === 'zh' ? '/zh/nft/' : '/nft/'", v-if="workName") ← {{ $t('nft.catalog.title') }}
    router-link.back-link.nft-record-back(v-if="currentRecord", :to="recordPath(currentRecord.slug)") {{ $i18n.locale === 'zh' ? '作品介紹、影像與來源' : 'Artwork, images and sources' }} →
  PageNftMemes(v-if="workName == 'memes'")
  //- 2026-09-20：/nft/electriz/ 改成 910 版資料庫（2021 子頁的概念文與過程圖併進 /work/electriz/）；獨立 chunk
  NftElectrizEditions(v-if="workName == 'electriz'")
  NftSliderverseEditions(v-if="workName == 'sliderverse'")
  PageNftFoundation(v-if="workName == 'foundation'")
  //- 2026-09-20：/nft/thesoulofflowers/ 改成 200 版資料庫（介紹在 /work/soul-of-flowers/）；獨立 chunk
  NftSoulOfFlowersEditions(v-if="workName == 'thesoulofflowers'")
  NftSoulseaEditions(v-if="workName == 'soulsea'")
  NftCryptopochiEditions(v-if="workName == 'cryptopochi'")
  //- 2026-10-04：/nft/fabdao/ 是百岳計畫《島嶼》569 枚資料庫（官方 token 服務下線後的自記錄；介紹在 /work/fabdao/）；獨立 chunk
  NftFabdaoEditions(v-if="workName == 'fabdao'")
  //- 2026-09-20：/nft/soulfish/ 是 400 版資料庫（作品介紹在 /work/soulfish/）；獨立 chunk，索引頁不用載那 190 KB 的資料
  NftSoulfishEditions(v-if="workName == 'soulfish'")
  site-links(v-if="workName")
</template>

<script>
import PageNftFoundation from "./pageNftFoundation.vue";
import SiteLinks from '@/components/ui/SiteLinks.vue';
import PageNftMemes from "./pageNftMemes.vue";
import workCatalog from '@/data/work-catalog.json';
import { withSlash } from '@/runtime/site-path.mjs';
import { defineAsyncComponent } from 'vue';
const NftSoulfishEditions = defineAsyncComponent(() => import('@/components/nft/NftSoulfishEditions.vue'));
const NftSoulOfFlowersEditions = defineAsyncComponent(() => import('@/components/nft/NftSoulOfFlowersEditions.vue'));
const NftSoulseaEditions = defineAsyncComponent(() => import('@/components/nft/NftSoulseaEditions.vue'));
const NftElectrizEditions = defineAsyncComponent(() => import('@/components/nft/NftElectrizEditions.vue'));
const NftSliderverseEditions = defineAsyncComponent(() => import('@/components/nft/NftSliderverseEditions.vue'));
const NftCryptopochiEditions = defineAsyncComponent(() => import('@/components/nft/NftCryptopochiEditions.vue'));
const NftFabdaoEditions = defineAsyncComponent(() => import('@/components/nft/NftFabdaoEditions.vue'));
export default {
  data() {
    return {
      nftItems: [
        {
          id: 1,
          title: "Urban Contour",
          platform: "Fxhash",
          date: "Jan 5th 2024",
          editions: "114",
          description1: `「 In the urban mirage, phantoms dance with time's fleeting gleam,
                          <br> Where futures are still under construction, like a dream.
                          <br> With the solid forms of the material world, we trace,
                          <br> Undefined beauties and fantasies, a wistful space. 」 / Che-Yu Wu`,
          description2: `"Urban Contour" is a generative Impressionist program art piece that constructs a collective subconscious of a city. In many fragments, we can discover aspects similar to our own living environments. This artwork is a collective made up of everyone's impressions of the city. Within its abstract lines and structures, it connects the memories of each individual, carrying our dreams and fantasies about the future and ourselves.`,
          imageUrl: "/static/nft/urban_contour/main.jpeg",
          url: "/work/urban-contour/",
        },
        {
          id: 2,
          title: "The Soul of Flowers",
          platform: "Fxhash",
          date: "Dec 6th 2023",
          editions: "200",
          description1: `In the vast open fields, I once glimpsed the beauty of blooming flowers, Heard indescribable murmurs that became unforgettable. With longing and pain, I moved slowly forward, crossing the northern seas. In a blink, the origin of this long journey seemed lost.`,
          description2: `Lost in the dawn before the storm, I discovered that some things in life were quietly changing direction. Perhaps, we are living more transparently, more authentically. After releasing this series of works, I am filled with indescribable complex emotions. Perhaps a fragment of the soul has indeed achieved life and will eternally exist. Eventually blossoming into a field of flowers, existing forever. What's wrong with living willfully? Forget everything. On the island of flowers, it's best to be a happy caterpillar.`,
          imageUrl: "/static/nft/the_soul_of_flowers/flower demo.jpeg",
          url: "/nft/thesoulofflowers/",
        },
      ],
    };
  },
  metaInfo() {
    if (this.workName == "electriz") {
      return {
        title: "Electriz — the 910 editions by Che-Yu Wu",
        meta: [
          {
            property: "og:image",
            content: "/static/img/electriz/cover-2026-09.jpg",
          },
        ],
      };
    } else if (this.workName == "foundation") {
      return {
        title: "Foundation by Che-Yu Wu",
        meta: [
          {
            property: "og:image",
            content: "/static/img/foundation-og.png",
          },
        ],
      };
    } else if (this.workName == "thesoulofflowers") {
      return {
        title: "The Soul of Flowers — the 200 editions by Che-Yu Wu",
        meta: [
          {
            property: "og:image",
            content: "/static/nft/the_soul_of_flowers/flower demo.jpg",
          },
        ],
      };
    } else if (this.workName == "sliderverse") {
      return {
        title: "Sliderverse × White Castle — the 1,285 editions by Che-Yu Wu",
        meta: [
          {
            property: "og:image",
            content: "/static/img/sliderverse/cover-2026-09.jpg",
          },
        ],
      };
    } else if (this.workName == "fabdao") {
      return {
        title: "Project %: Island — the 569 tokens by Che-Yu Wu",
        meta: [
          {
            property: "og:image",
            content: "/static/img/fabdao/cover-2026-10.jpg",
          },
        ],
      };
    } else if (this.workName == "cryptopochi") {
      return {
        title: "CryptoPochi — the 732 editions by Che-Yu Wu",
        meta: [
          {
            property: "og:image",
            content: "/static/img/cryptopochi/cover-2026-09.jpg",
          },
        ],
      };
    } else if (this.workName == "soulsea") {
      return {
        title: "SoulSea — the 300 editions by Che-Yu Wu",
        meta: [
          {
            property: "og:image",
            content: "/static/img/soulsea/cover-2026-09.jpg",
          },
        ],
      };
    } else if (this.workName == "soulfish") {
      return {
        title: "SoulFish — the 400 editions by Che-Yu Wu",
        meta: [
          {
            property: "og:image",
            content: "/static/img/soulfish/cover-2026-09.jpg",
          },
        ],
      };
    } else if (this.workName == "memes") {
      return {
        title: "Interactive Memes by Che-Yu Wu",
        meta: [
          {
            property: "og:image",
            content: "/static/img/memes-og.png",
          },
        ],
      };
    }
  },
  computed: {
    collectionRecords() { return workCatalog.filter(work => work.category === 'nft'); },
    currentRecord() { return this.collectionRecords.find(work => work.legacyPath === '/nft/' + this.workName) || workCatalog.find(work => work.slug === this.workName); },
    workName() {
      return this.$route.params.name;
    },
  },
  methods: {
    withSlash,
    recordPath(slug) { return (this.$i18n.locale === 'zh' ? '/zh' : '') + '/work/' + slug + '/'; },
    isInternalLink(url) {
      // Implement logic to determine if the URL is an internal link
      // For example, check if URL starts with '/' for simplicity
      return url.startsWith("/");
    },
    getLinkComponent(url) {
      // Returns 'router-link' for internal links, otherwise returns 'a'
      return this.isInternalLink(url) ? "router-link" : "a";
    },
  },
  components: {
    NftSoulfishEditions,
    PageNftMemes,
    PageNftFoundation,
    NftSoulOfFlowersEditions,
    NftSoulseaEditions,
    NftElectrizEditions,
    NftSliderverseEditions,
    NftCryptopochiEditions,
    NftFabdaoEditions,
    SiteLinks,
  },
};
</script>

<style lang="sass">
.page-nft-all
  background-color: var(--bg0)
  color: var(--ink)
  .nft-record-index
    display: grid
    grid-template-columns: repeat(auto-fit, minmax(min(100%, 230px), 1fr))
    gap: 12px 24px
    margin: 24px 0 56px
    padding: 24px 0
    border-block: 1px solid var(--line)
    a
      color: var(--ink-2)
      font-size: 0.95rem
      padding: 8px 0
      &:hover, &:focus-visible
        color: var(--gold)
  .nft-record-back
    display: inline-block
    margin: 12px 24px
  .catalog-head
    padding: 24px 0 8px
    text-align: center
  .catalog-title
    font-family: var(--font-slab)
    font-size: clamp(2.6rem, 2rem + 2vw, 4rem)
    font-weight: 600
  .catalog-sub
    color: var(--ink-3)
    font-size: 1.05rem
    max-width: 62ch
    margin: 8px auto 0
  h2
    margin-top: 50px
    font-family: var(--font-slab)
  h5
    color: var(--ink-3)
    font-size: 1rem
    letter-spacing: 0.04em
  p
    color: var(--ink-2)
  a
    color: var(--ink)
    &:hover
      text-decoration: none
  .back-link
    color: var(--ink-3)
    font-size: 0.95rem
    letter-spacing: 0.04em
    transition: var(--t-hover)
    &:hover
      color: var(--gold)
  .container
    max-width: var(--content-w)
  // 作品列：無框面板，hover 換底色（不位移）
  .nft-item
    background-color: var(--bg1)
    transition: var(--t-hover)
    margin-top: 30px
    border-radius: var(--r-lg)
    &:hover
      background-color: var(--bg2)
</style>

<style>
@media(max-width:575px){.page-nft-all .page-nft h1{font-size:clamp(2.5rem,11vw,4rem);overflow-wrap:anywhere}.page-nft-all .page-nft pre{white-space:pre-wrap;overflow-wrap:anywhere}.page-nft-all iframe{max-width:100%}}
</style>

<style scoped>
.nft-index-disclosure { margin:20px 0; }
.nft-index-disclosure summary { min-height:44px; cursor:pointer; padding:12px 0; color:var(--ink-2); }
.nft-index-disclosure summary:focus-visible { outline:2px solid var(--gold); outline-offset:4px; }
@media(max-width:640px) { .catalog-head { padding-bottom:8px; } .nft-record-index { margin:12px 0; } }
</style>
